import React from "react";
import logo from "./logo.jpg";

const Logo = () => <img src={logo} alt="logo" />;

export default Logo;
